import { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";

import {
    ArcElement,
    Chart as ChartJS,
    Legend,
    Tooltip
} from "chart.js";

import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

export default function TaskEvaluationChart({ data }) {
    const chartData = useMemo(() => {
        const sorted = [...data].sort(
            (a, b) => Number(b.total) - Number(a.total)
        );

        return {
            labels: sorted.map((item) => item.label),

            datasets: [
                {
                    label: "Atividades",
                    data: sorted.map((item) => Number(item.value)),
                    backgroundColor: ['rgba(90,180,232,0.65)', 'rgba(115, 98, 138, 0.65)'],
                    borderColor: ['#5ab4e8', '#73628a'],
                    borderWidth: 2,
                    spacing: 0,
                },
            ],
        };
    }, [data]);

    const options = useMemo(
        () => ({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: true, },
                tooltip: {
                    callbacks: {
                        label: (context) =>
                            `${context.raw} ${context.raw === 1 ? 'movimentação' : 'movimentações'}`,
                    },
                },

                datalabels: {
                    anchor: 'end',
                    align: "center",
                    color: "#0e0e0e",
                    clamp: true,
                    backgroundColor: ['#5ab4e8', '#73628a'],
                    borderRadius: 16,
                    font: {
                        weight: "bold",
                    },
                    formatter: (value) => `${value}`.padStart(2, '0'),
                },
            },
        }),
        []
    );

    return (
        <div
            style={{
                height: Math.max(
                    data.length * 45,
                    400
                ),
            }}
        >
            <Doughnut
                data={chartData}
                options={options}

            />
        </div>
    );
}